import { render, staticRenderFns } from "./OnlineUser.vue?vue&type=template&id=5b10ae71&scoped=true&"
import script from "./OnlineUser.vue?vue&type=script&lang=js&"
export * from "./OnlineUser.vue?vue&type=script&lang=js&"
import style0 from "./OnlineUser.vue?vue&type=style&index=0&id=5b10ae71&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b10ae71",
  null
  
)

export default component.exports